// extracted by mini-css-extract-plugin
export default {"label":"label__eD2p1","selectContainer":"selectContainer__aLvpe","select":"select__l1vJC","check":"check__lZXhd"};